import { createContextFactory } from '@streem/toolbox';
export const [InvitationDetailsProvider, useInvitationDetails,] = createContextFactory('InvitationDetails');
//# sourceMappingURL=invitation_details.js.map